<template>
  <div>
    <h6 class="mb-8 font-bold text-1xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('diarios')">Customer:</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ nombre.contact_nombres}} 
    </h6>
    <trashed-message v-if="diario.deleted_at" class="mb-6" @restore="restore">
     Estimate Removed!
    </trashed-message>
     <h1 class="mb-8 font-bold text-1xl"> Detail Estimate </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="updateventa">
          <p>Description:</p>
       <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <textarea v-model="form2.descripcion" :error="form.errors.descripcion" class="border-solid border-2 border-sky-500 pr-6 pb-8 w-3/6"/>
         <text-input v-model.number="form2.reporte_diario_id" :error="form.errors.reporte_diario_id" class="invisible left-0 top-0 h-16 w-1/6" label="Nº"/> 
          <text-input v-model="form2.valor" :error="form.errors.valor" class="pr-6 pb-8 w-2/6" label="Amount" />
                    
          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Add Item</loading-button>
        </div>
      </form>
    </div>
    <br>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <div class="flex flex-col">
    <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block py-2 min-w-full sm:px-6 lg:px-8">
            <div class="overflow-hidden shadow-md sm:rounded-lg">
          <table class="min-w-full">
        <thead class="bg-gray-50 dark:bg-gray-700">
                        <tr>
                            <th scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                               Description
                            </th>
                            <th scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                               Amount
                            </th>
                        </tr>
                    </thead>
                    <tbody>
    <tr v-for="detalle in detalles" :key="detalle.id" class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
          <td>
            <inertia-link class="px-6 py-4 flex items-center" :href="route('diariosdetalles.edit', detalle.id)" tabindex="-1">
              {{ detalle.descripcion }}
            </inertia-link>
          </td>
          <td>
             <inertia-link class="px-6 py-4 flex items-center" :href="route('diariosdetalles.edit', detalle.id)" tabindex="-1">
              {{ detalle.valor }}
            </inertia-link>
          </td>
         
          <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
            <inertia-link class="px-4 flex items-center" :href="route('diariosdetalles.edit', detalle.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="detalles.length === 0">
          <td class="border-t px-6 py-4" colspan="4">Not Data Found</td>
        </tr>
       </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
    </div>
    <br>
    <h1 class="mb-8 font-bold text-1xl"> Header Estimate </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
 
       <form @submit.prevent="update">
       <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
         <text-input v-model="form.observacion" :error="form.errors.observacion" class="pr-6 pb-8 w-full" label="Observacion" />
         <text-input v-model="form.fecha" :error="form.errors.fecha" class="invisible pr-6 pb-8 w-1/4" label="Fecha" />
          <text-input v-model="form.subtotal" :error="form.errors.subtotal" class="invisible pr-6 pb-8 w-1/4" label="Subtotal" />
           <text-input v-model="form.iva" :error="form.errors.iva" class="invisible pr-6 pb-8 w-1/4" label="Iva" />
            <text-input v-model="form.total" :error="form.errors.total" class="invisible pr-6 pb-8 w-1/4" label="Total" />
          
          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!diario.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Estimate</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Saved Estimate</loading-button>
        </div>
      </form>

    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  
  metaInfo() {
    return {
      title: `${this.nombre.contact_nombres}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    diario: Object,
    nombre: Object,
    detalles: Array,
    contacts: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        fecha: this.diario.fecha,
        observacion: this.diario.observacion,
        subtotal: this.diario.subtotal,
        iva: this.diario.iva,
        total: this.diario.total,


      }),
       form2: this.$inertia.form({
        reporte_diario_id: this.diario.id,
        descripcion: null,
        valor: null,
      


      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('diarios.update', this.diario.id))
    },
    updateventa() {
     this.form2.post(this.route('diariosdetalles.store'))
    },
    destroy() {
      if (confirm('Estas Seguro de Eliminar?')) {
        this.$inertia.delete(this.route('diarios.destroy', this.diario.id))
      }
    },
    restore() {
      if (confirm('Piensalo Bien!?')) {
        this.$inertia.put(this.route('diarios.restore', this.diario.id))
      }
    },
  },
  
}
</script>
